module.exports = __webpack_public_path__ + "media/images/lp/1/support1-pc-6aced6abe0be4b00a7e562e3b0be8f66.png";